import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHandbookEmbed } from '../../context/HandbookEmbedContext';

/**
 * HR Self-Service / Handbuch-Chatbot (Vite-Build unter public/hr-self-service-chatbot/).
 * API: CRA-Proxy → Port 3002, Präfix /api/hr-handbook (ohne Konflikt mit Entgelt /api/chat).
 */
const HrHandbookChatbotResource = () => {
  const [searchParams] = useSearchParams();
  const ctx = useHandbookEmbed();
  const src = useMemo(() => {
    const q = new URLSearchParams(searchParams);
    q.set('portalEmbed', '1');
    const s = q.toString();
    return `/hr-self-service-chatbot/index.html?${s}`;
  }, [searchParams]);

  const handleLoad = () => {
    ctx?.setEmbedReady?.(true);
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 bg-slate-100">
      <iframe
        title="HR Self-Service Chatbot"
        src={src}
        ref={ctx?.setIframeEl}
        onLoad={handleLoad}
        className="w-full flex-1 min-h-[520px] border-0 block bg-white"
      />
    </div>
  );
};

export default HrHandbookChatbotResource;
